var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v("MEDPadala Balance:")]),_c('h2',{staticClass:"text-primary",style:({
      color:
        _vm.webDesign && _vm.webDesign.design
          ? ((_vm.webDesign.design.main_color) + " !important")
          : null
    })},[_vm._v(" Php "+_vm._s(_vm._f("twoDecimalPlaces")(_vm.medPadalaData.balance))+" ")]),_c('p',{staticClass:"text-muted"},[_vm._v(" As of "+_vm._s(_vm._f("moment")(_vm.medPadalaData.milliseconds_date,"MMMM D, YYYY"))+" ")]),_c('div',{staticClass:"py-3"},[(_vm.medPadalaData.balance === 0)?_c('b-button',{staticClass:"py-2 bg-transparent border-0 text-uppercase text-muted shadow-none",attrs:{"block":"","pill":""},on:{"click":function($event){_vm.medPadalaStep = 1}}},[_vm._v(" Back ")]):_c('b-button',{staticClass:"border-0 py-2 text-uppercase",style:({
        backgroundColor:
          _vm.webDesign && _vm.webDesign.design
            ? ((_vm.webDesign.design.main_color) + " !important")
            : null,
        color:
          _vm.webDesign && _vm.webDesign.design
            ? ((_vm.webDesign.design.button_text_color) + " !important")
            : null
      }),attrs:{"variant":"primary","block":"","pill":""},on:{"click":function($event){_vm.medPadalaStep = 3}}},[_vm._v(" Next ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }